import { buildSplunkUrl } from './build-splunk-url';
import { getSplunkTimeRangeParams } from './get-splunk-time-range-params';

/**
 * Returns a Splunk search URL for an ELS (Entity Linking Service) trace ID.
 *
 * ELS logs live in the `micros_kserving-entity-linking` source, are scoped to
 * production (`env=prod*`), and match the trace ID as a bare search term, so
 * this uses a different query shape than `getSplunkTraceUrl`:
 *
 *   `micros_kserving-entity-linking` env=prod* <traceId>
 *
 * Returns `undefined` when no trace ID is available. Honours the same absolute
 * time-window behaviour as `getSplunkTraceUrl`.
 *
 * @param traceId - The ELS trace ID to search for.
 * @param timestamp - Optional time of the request (ISO 8601 string or epoch ms)
 *   used to anchor the Splunk search window.
 */
export const getSplunkElsTraceUrl = (
	traceId: string | null | undefined,
	timestamp?: string | number | null,
): string | undefined => {
	if (!traceId) {
		return undefined;
	}

	return buildSplunkUrl(
		`\`micros_kserving-entity-linking\` env=prod* ${traceId}`,
		getSplunkTimeRangeParams(timestamp),
	);
};
